<template lang="pug">
  .d-flex.justify-content-center
    a.px-1(href="#" v-for="item in actions" @click.prevent="$emit('action',item.name)")
      i(:class="item.class" v-if="item.type=='icon'")
      btn.btn-sm(v-else :class="item.class") {{item.label}}

</template>

<script>
export default {
  props: ['actions']
}
</script>